<template>
    <div>
        <p>{{ $t('signal_viewer.modals.frequency_signal_selector_modal.title') }}</p>
        <DxSelectBox :items="signalDataSource" :value="0" displayExpr="name" valueExpr="index"
            @selectionChanged="signalChanged"></DxSelectBox>
    </div>
</template>

<script setup lang="ts">
import { DxSelectBox } from "devextreme-vue";
import type { FrequencyDialogResult } from "./osc";
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import type { SelectionChangedEvent } from "devextreme/ui/select_box";
import { useModalBuilder } from "@/.shared/helpers/modal-building-helper";

const modal = useModalBuilder();
const props = defineProps<{ signals: string[] }>();
const result: FrequencyDialogResult = {
    signal: null,
    result: "cancel"
};
const signalDataSource = computed(() => {
    return props.signals.map((s, idx) => ({ name: s, index: idx }));
})

onMounted(() => {
    modal.setContext(getCurrentInstance()!);
    const { okButton, cancelButton } = modal.standardButtons.addOkCancel();

    okButton.update(b => {
        b.onClick = () => {
            result.result = "ok";
            modal.close(result);
        };
    });

    cancelButton.update(b => {
        b.onClick = () => {
            result.result = "cancel";
            modal.close(result);
        }
    });

});

function signalChanged(e: SelectionChangedEvent) {
    result.signal = e.selectedItem.index;
}
</script>